// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"a45871d3","213":"c22d7b83","238":"9ba0e6f7","239":"bea84e58","455":"fb85a4fc","557":"2082121a"}[chunkId] + ".chunk.js";
};